import { render, staticRenderFns } from "./Typography.vue?vue&type=template&id=5d43aac0&scoped=true"
import script from "./Typography.vue?vue&type=script&lang=ts"
export * from "./Typography.vue?vue&type=script&lang=ts"
import style0 from "./Typography.vue?vue&type=style&index=0&id=5d43aac0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d43aac0",
  null
  
)

export default component.exports